import React from 'react';
import TextInputField from '../TextInputField/TextInputField';
import { emailRegisterOptions } from '../patterns';

export default function EmailField({
  register,
  errors,
  registerOptions = emailRegisterOptions,
  name = 'email',
  placeholder = 'Email',
  labelText = 'Email address',
  labelRightElement = null,
  ...props
}) {

  return <TextInputField
    {...props}
    register={register}
    errors={errors}
    registerOptions={registerOptions}
    name={name}
    placeholder={placeholder}
    labelText={labelText}
    labelRightElement={labelRightElement}
  />
}
